export const TITLE_BUESNESS = import.meta.env.VITE_TITLE_BUSINESS
export const TITLE = import.meta.env.VITE_TITLE

export const commonTableDateFormat = "YYYY-MM-DD HH:mm";